<template>
    <z-scrollDiv class="wrap-dashboard">
        <!-- 个人信息 -->
        <div class="item-box user">
            <div class="head">
                <div class="text-title">
                    <img src="~src/assets/image/dash-user.svg">个人信息
                </div>
                <div class="text-add">{{ user.position_name }}</div>
                <z-lazyImg class='userimg' :src="userInfo.userLogo"></z-lazyImg>
            </div>
            <div class="main">
                <div class="info">
                    <div>
                        <div class='overhide'>姓名：<span :title="user.real_name">{{ user.real_name }}</span></div>
                        <div>职级：<span>{{ user.staffing_grade }}</span></div>
                    </div>
                    <div>
                        <div>工号：<span>{{ user.user_name }}</span></div>
                        <div>身份：<span>{{ user.bu_identity_type == 1 ?"合伙人":"职员" }}</span></div>
                    </div>
                </div>
                <div class="info overhide">所属BU：<span :title="bu.bu_name">{{ bu.bu_name }}</span></div>
                <p v-if="userInfo.bu.type == 0">经营范围</p>
                <div>{{ sub_range }}</div>
            </div>
        </div>

        <!-- 任务管理 -->
        <div class="item-box task" v-if='code(1000)'>
            <div class="head">
                <div class="text-title">
                    <img src="~src/assets/image/dash-task.svg">任务管理
                </div>
            </div>
            <div class="main">
                <div class="middle">
                    <div class="number"><span class="big font">{{ task.solve_size }}</span>件</div>
                    <div>待处理任务</div>
                </div>
                <div class="bottom">
                    <div class="bottom-item">
                        <div><span class="big">{{ task.release_size }}</span>件</div>
                        <div>待发布任务</div>
                    </div>
                    <div class="bottom-item">
                        <div><span class="big">{{ task.end_size }}</span>件</div>
                        <div>已结束任务</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 个人财务 -->
        <!-- <div class="item-box bonus">
            <div class="head">
                <div class="text-title">
                    <img src="~src/assets/image/dash-bonus.svg">个人财务
                </div>
            </div>
            <div class="main">
                <div class="middle">
                    <div class="title">个人奖金</div>
                    <div class="list">
                        <div class="list-item">
                            <div class="font big">{{ "1000" }}</div>
                            <div>{{ "A快币" }}</div>
                        </div>
                        <div class="list-item">
                            <div class="font big">{{ "1000" }}</div>
                            <div>{{ "B快币" }}</div>
                        </div>
                        <div class="list-item">
                            <div class="font big">{{ "1000" }}</div>
                            <div>{{ "C快币" }}</div>
                        </div>
                        <div class="list-item">
                            <div class="font big">{{ "1000" }}</div>
                            <div>{{ "D快币" }}</div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-item">
                        <div><span class="big">{{ "50" }}</span>币</div>
                        <div>个人罚单</div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- 文档管理 -->
        <div class="item-box doc" v-if='code(1200)'>
            <div class="head">
                <div class="text-title">
                    <img src="~src/assets/image/dash-doc.svg">文档管理
                </div>
            </div>
             <div class="main">
                <div class="middle">
                    <div class="number"><span class="big font">{{ doc.all_doc_size }}</span>份</div>
                    <div>文档</div>
                </div>
                <div class="bottom">
                    <div class="bottom-item">
                        <div><span class="big">{{ doc.task_doc_size }}</span>份</div>
                        <div>任务文档</div>
                    </div>
                    <div class="bottom-item">
                        <div><span class="big">{{ doc.task_tpl_doc_size }}</span>份</div>
                        <div>文档模板</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- BU管理 -->
        <div class="item-box bu special" v-if='code(1300)' @mouseenter="move_flag = true" @mouseleave='move_flag = false'>
            <div class="head">
                <div class="text-title">
                    <img src="~src/assets/image/dash-bu.svg">BU管理
                </div>
                <div class="text-add">{{ data.bonusCycleDetail && `${data.bonusCycleDetail.cycle_year}#${data.bonusCycleDetail.cycle_number}` }}</div>
            </div>
            <div class="main">
                <div class="middle">
                    <div class="number"><span class="big font">{{ curr.current_currency_balance | money }}</span>{{ curr.currency_name }}</div>
                    <div>BU奖金</div>
                </div>
                <!-- <div class="middle">
                    <div class="title">BU奖金</div>
                    <div class="list-item">
                        <span class="font big">{{ curr.current_currency_balance | money}}</span>
                        <span>{{ curr.currency_name }}</span>
                    </div>
                </div> -->
                <div class="bottom">
                    <div class="bottom-item">
                        <div><span class="big">{{ data.pmtLevelSummary && data.pmtLevelSummary.balance || 0 }}</span>级</div>
                        <div>可分配职级</div>
                    </div>
                    <div class="bottom-item">
                        <div><span class="big">{{ data.ticketSum && data.ticketSum.ticket_sum }}</span>币</div>
                        <div>BU罚单币</div>
                    </div>
                </div>
            </div>
        </div>

    </z-scrollDiv>    
</template>
<script>
    import { mapState,mapGetters } from 'vuex'
    export default {


        data() {
            return {
                data:{},
                // move_flag:false,  //奖金滚动判断

                list:{
                    move:'',   //move 距离
                    count:1,   //count  
                    timer:'',  //定时器
                }
            };
        },

        computed: {
            ...mapState(['userInfo']),
            ...mapGetters(['codeList']),
            user(){ 
                return this.data.user || {};
            },
            sub_range(){  //经营范围 文本
                let text = this.user.manage_range && this.user.manage_range.map(item=>item.tpl_name).join(',') || ""; 
                if(text.length>=50){
                    return text.substr(0,50)+"..."
                }
                return text;
            },
            bu(){
                return this.data.bu || {};
            },
            task(){
                return this.data.taskSizeMap || {};
            },
            doc(){
                return this.data.docMap || {};
            },
            curr(){   //快币情况
                return this.data.currAccountInfoList?this.data.currAccountInfoList[0] : {};
            },
        },

        created() {
            this.getData();
        },

        filters:{
            money(val){
                let num = parseInt(val);
                if( num > 10000){
                    num = (num/1000).toFixed(1)+"k";
                }
                return num;
            },
        },

        watch:{
            // 'data.currAccountInfoList'(val){
            //     let obj = this.$refs['list'];
            //     if(!obj){
            //         return;
            //     }
            //     this.list.move = obj.clientWidth;
            //     obj.style.transform =  `translateX(0)`;
            // },
            // move_flag(val){
            //     if(val){
            //         this.startMove();
            //     }else{
            //         this.endMove();
            //     }
            // }
        },

        methods: {
            getData(){
                let url = `api/user/dashbord`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                }).catch(err=>{
                    console.log(err);
                });
            },

            // ****动画效果
            // startMove(){
            //     this.list.timer = setInterval(()=>{
            //         this.move();
            //     },2000);
            // },
            // endMove(){
            //     clearInterval(this.list.timer);
            //     this.move(0);
            // },
            // move(index){  //移动
            //     if(index == 0){   //重置位置
            //         this.list.count = 1;
            //         this.$refs['list'].style.transform = `translateX(0)`;
            //         return;
            //     }
            //     let arr = this.data.currAccountInfoList || [];
            //     let len = Math.ceil(arr.length/3);  //一行3个
            //     if(this.list.count == len){  //重置位置
            //         this.list.count = 1;
            //         this.$refs['list'].style.transform = `translateX(0)`;
            //         return;
            //     }
            //     let str = this.$refs['list'].style.transform;
            //     this.$refs['list'].style.transform = `translateX(${this.getNum(str)-this.list.move}px)`
            //     this.list.count++;
            // },
            // getNum(str){  //获取括号内的值
            //     return parseInt(str.replace(/[\(\)]|(px\))/g,'|').split("|")[1]);
            // },

            // 其他
            link(name){

            },
            code(val){  //验证权限
                return this.codeList.some(code=>code==val) && this.userInfo.bu.type == 0;
            },
        },



    };

</script>
<style lang="less" scoped>
    @import "~src/assets/less/var.less";

    @color_1:#01b7ad;
    @color_2:#7f34f2;
    @color_3:#3a5ade;
    @color_4:#00b993;
    @color_5:#02a2cf;
    @head_h : 50px;  //彩色头部高度
    @width :300px;  //项目宽度

    // 奖金浮层阴影
    // .list-view{
    //     overflow: hidden;
    //     transition:0.3s;
    //     padding-bottom: 14px;
    //     position: relative;
    //     background:rgba(255,255,255,0.6);
    //     &.shadow{
    //         box-shadow: 0 0 6px 0 rgba(141, 141, 141, 0.5);
    //         transform: scale(1.1);
    //     }
    // }

    .wrap-dashboard{
        height:100%;
        padding-left: 40px;
        box-sizing: border-box;
        color:#737373;
        .clear();
    }

    .item-box{
        width: @width;
        height:260px;  
        border-radius:8px;
        background:#fff;
        box-shadow:0 0 6px 0 rgba(141,141,141,0.50);

        float: left;
        margin-left: 25px;
        margin-top: 40px;
        overflow: hidden;
        .head{
            height: @head_h;
            line-height: @head_h;
            color:#fff;
            box-sizing: border-box;
            padding: 0 25px;
            font-size:14px;
            position: relative;
            .clear();

            .text-title{
                float: left;
                img{
                    position: relative;
                    display: inline-block;
                    width:20px;
                    height: 20px;
                    vertical-align: sub;
                    top:2px;
                    margin-right: 5px;
                }
            }
            .text-add{
                float:right;
            }
            // 用户头像
            >.userimg{
                width:60px;
                height: 60px;
                border-radius: 50%;
                display:block;
                position: absolute;
                left: 50%;
                bottom:0;
                transform: translate(-50%,50%);
                background:#ccc;
                border: 2px solid #fff;
            }
        }

        .main{
            height:calc(~"100% - @{head_h}");
            box-sizing: border-box;
            .middle{
                height:130px;
                text-align: center;
                padding-top: 0.1px;
                .number{
                    line-height: 30px;  //调整数字和下方文字间距
                }
                >.number{
                    margin-top: 36px;
                }

                .title{
                    margin:15px 0;
                }

                // 列表数据
                .list{
                    font-size:0;
                    white-space: nowrap;
                    transition: transform 0.3s;

                    // &:hover{
                    //     animation: key 2s linear infinite alternate;
                    // }
                }   
                .list-item{
                    width: @width/3;
                    text-align: center;
                    font-size:12px;
                    display: inline-block;
                    position: relative;
                    .big{
                        font-size:32px;
                    }
                }
            }

            .bottom{
                height:calc(~"100% - 130px");
                box-sizing: border-box;
                text-align: center;
                background:#fcfcfc;
                border-top: 1px solid #e6e6e6;
                .clear();
                .bottom-item{
                    position: relative;
                    font-size:12px;
                    top:50%;
                    transform: translateY(-50%);
                    float:left;
                    .big{
                        font-size:26px;
                        display: inline-block;
                        margin-right: 5px;
                    }
                }
                .bottom-item+.bottom-item{
                    position: relative;
                    &:before{
                        position: absolute;
                        content: "";
                        display:block;
                        left:0;
                        top: 10%;
                        height: 80%;
                        width:1px;
                        background:#e6e6e6;
                        z-index:1;
                    }
                }
            }
        }

        .tip{
            font-size:12px;
        }
        .big{
            font-size:48px;
        }

        // 颜色循环
        .loop(@counter) when (@counter > 0) {
            .loop(@counter - 1);
            &:nth-of-type(@{counter}){
                .head{
                    background:~"@{color_@{counter}}";
                }
                // 带颜色的字体
                .font{
                    color:~"@{color_@{counter}}";
                }
            }
        }
        .loop(5);
    }

    .item-box.user{
        .main{
            padding:44px 18px 0;
            .info{
                span{
                    font-weight:600;
                }
                .clear();
                >div{
                    float:left;
                }
                >div:nth-of-type(1){
                    width: 150px;
                }
            }
            >p{
                margin:8px 0;
                text-align: center;
                font-weight:700;
                &+div{
                    text-align: center;
                }
            }
        }
    }

    .item-box.task{
        .bottom-item{
            width:50%;
        }
    }

    .item-box.doc{
        .bottom-item{
            width:50%;
        }
    }
    
    .item-box.bonus{
        .bottom-item{
            width:100%;
        }
    }

    .item-box.bu{
        .bottom-item{
            width:50%;
        }
    }

    .item-box.special{
        overflow: visible;
        >.head{
            border-radius: 8px 8px 0 0;
        }
        >.main >.bottom{
            border-radius: 0 0 8px 8px;
        }
    }

    @keyframes key {
        0%{
            transform:translateX(0%);
            // left:0;
            left:0;
        }
        100%{
            // left:calc(~"100% - ");
            left:-100%;
            transform: translateX(@width);
        }
    }
    // @keyframes key {
    //     0%{
    //         background:#fff
    //     }
    //     100%{
    //         background:#aef8ce;
    //     }
    // }



</style>



// WEBPACK FOOTER //
// page-dashboard.vue?0d6f9b20